import React from 'react';

import CharmaLogo from 'Shared/components/Logos/CharmaLogo';
import danAvatar from 'Shared/images/dan.png';
import dialpadLogo from 'Shared/images/dialpad.png';

import './OnboardingTestimonial.scss';

function OnboardingTestimonial() {
  return (
    <div className="onboarding-testimonial d-flex flex-column justify-content-between position-relative flex-shrink-0 p-4 h-100 w-100">
      <CharmaLogo width="230" className="mb-4 ml-5 mt-2" />
      <div className="onboarding-testimonial-content h-100 my-4 p-5">
        <div className="d-flex align-items-center">
          <div className="onboarding-testimonial-avatar circle d-flex align-items-center justify-content-center p-1 mb-2">
            <img className="circle" src={danAvatar} alt={danAvatar} width={80} />
          </div>
          <div className="d-flex flex-column ml-3">
            <div className="onboarding-testimonial-name">Dan O’Connell</div>
            <div className="onboarding-testimonial-position d-flex align-items-center mb-2">
              CSO/CRO at{' '}
              <img src={dialpadLogo} alt={dialpadLogo} className="testimonials-dialpad-logo ml-2" width="90" />
            </div>
          </div>
        </div>
        <div className="onboarding-testimonial-position-speech">
          “With the shift towards hybrid work, PI Perform went from being a helpful tool to a critical piece of
          infrastructure. We use it to execute daily tasks & stay in sync with how employees are feeling day-to-day.”
        </div>
      </div>
      <div className="mt-4" style={{ height: '35px' }} />
    </div>
  );
}

export default OnboardingTestimonial;
